module.exports = __webpack_public_path__ + "static/img/stethoscope.94e123c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nurses/stethoscope.svg
// module id = jvzd
// module chunks = 1